'use client';
import React from 'react';
import SectionWrapper from '@/components/SectionWrapper';
import CloudImage from '@/components/CloudImage';
import MediaContainer from '@/components/MediaContainer';
import { getAllByServiceType } from 'lib/services';
import Button from '@/components/Button';
import ButtonContainer from '@/components/ButtonContainer';

export default function PopularServices() {
  // Get only the services with serviceType "Full Detail"
  const fullDetailServices = getAllByServiceType('Full Detail');

  // Optionally, sort the services in a preferred order (e.g., elite, deluxe, then essentials)
  const order = ['deluxe', 'refresh', 'express'];
  const sortedServices = fullDetailServices.sort((a, b) => {
    const titleA = a.title.toLowerCase();
    const titleB = b.title.toLowerCase();
    const indexA = order.findIndex((keyword) => titleA.includes(keyword));
    const indexB = order.findIndex((keyword) => titleB.includes(keyword));
    return indexA - indexB;
  });

  return (
    <SectionWrapper id="popular-packages">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="mb-12 text-center text-gray-900">
          Our Most Popular Packages
        </h2>
        <div className="laptop:grid-cols-3 grid grid-cols-1 gap-8">
          {sortedServices.map((service) => (
            <div
              key={service.slug}
              className="from-secondary to-primary rounded-lg bg-gradient-to-r p-1 shadow-lg transition duration-300 hover:shadow-2xl"
            >
              <div className="bg-primary-foreground flex h-full flex-col rounded-lg p-6">
                <div className="relative">
                  <MediaContainer className="aspect-4/3">
                    <CloudImage src={service.imageSrc} alt={service.title} />
                  </MediaContainer>
                  <div className="absolute inset-0 rounded-md bg-gradient-to-t from-black via-transparent opacity-50"></div>
                </div>
                <p className="h4 mt-4 text-gray-800">{service.title}</p>
                <p className="mt-2 line-clamp-3 text-gray-600">
                  {service.description}
                </p>
                <p className="mt-2 text-gray-500 italic">{service.bestFor}</p>
                <div className="mt-auto">
                  <div className="mt-4">
                    <div className="grid grid-cols-2 gap-2">
                      {['small', 'medium', 'large', 'x-large'].map(
                        (size, idx) => (
                          <div
                            key={idx}
                            className="rounded border p-2 text-center"
                          >
                            <p className="text-sm text-gray-500 capitalize">
                              {size} vehicle
                            </p>
                            <p className="text-primary font-bold">
                              ${service.servicePricing[idx]}
                            </p>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                  <ButtonContainer className="mt-6 flex justify-center">
                    <Button href={`/services/car-detailing#${service.slug}`}>
                      Learn More &amp; Book Now
                    </Button>
                  </ButtonContainer>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
